import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-article-share__inner" }
const _hoisted_2 = { class: "c-article-share__list" }
const _hoisted_3 = ["aria-label"]

import { computed } from 'vue';
import type { ArticleShareProps } from '@/types/components/ArticleShare';
import utils from '@/utils';
import { shareToLinkedIn } from '@/utils/dom-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleShare',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);

const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});
const shareLabel = computed(() => fields.value?.shareLabel?.value || 'Share article');
const configuredShareUrl = computed(() => fields.value?.shareLink?.value?.href || '');

const shareAriaLabel = computed(() => shareLabel.value || 'Share article');

const getShareUrl = () => {
  if (configuredShareUrl.value) return configuredShareUrl.value;
  if (typeof window === 'undefined') return '';
  return window.location.href;
};

const handleShare = () => {
  const url = getShareUrl();
  shareToLinkedIn(url);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "c-article-share",
        style: _normalizeStyle(rootStyle.value)
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value?.list, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "c-article-share__list-item",
                    key: item.id
                  }, [
                    _createVNode(_component_Icon, {
                      svg: item?.fields?.icon?.value?.svgCode
                    }, null, 8, ["svg"]),
                    _createVNode(_component_JssRichText, {
                      class: "c-article-share__list-item-desc",
                      field: item?.fields?.desc
                    }, null, 8, ["field"])
                  ]))
                }), 128))
              ]),
              _createElementVNode("button", {
                class: "c-article-share__button",
                type: "button",
                "aria-label": shareAriaLabel.value,
                onClick: handleShare
              }, [
                _createVNode(_component_Icon, {
                  svg: fields.value?.shareIcon?.value.svgCode
                }, null, 8, ["svg"])
              ], 8, _hoisted_3)
            ])
          ]),
          _: 1
        })
      ], 4))
    : _createCommentVNode("", true)
}
}

})